import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Loading1"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", { d: "M21.7617 12.7383C21.3536 12.7383 21.0234 12.4081 21.0234 12C21.0234 10.7818 20.7855 9.60059 20.3139 8.48701C19.8601 7.41498 19.2035 6.44077 18.38 5.61797C17.5581 4.79338 16.5836 4.13656 15.5109 3.68408C14.3994 3.21445 13.2182 2.97656 12 2.97656C11.5919 2.97656 11.2617 2.64639 11.2617 2.23828C11.2617 1.83018 11.5919 1.5 12 1.5C13.4171 1.5 14.7932 1.77686 16.0872 2.32646C17.3382 2.85352 18.46 3.6123 19.4238 4.57617C20.3877 5.54004 21.1444 6.66387 21.6735 7.91279C22.2211 9.20684 22.4979 10.5829 22.4979 12C22.5 12.4081 22.1698 12.7383 21.7617 12.7383Z" }, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Loading1.vue"]]);
